'use strict';

import {wpActivityModel} from "../../models/wpactivitymodel.js";
import {participantModel} from "../../models/participantmodel.js";
import {reportWpDeliverableModel} from "../../models/reportwpdeliverablemodel.js";
import {wpModel} from "../../models/wpmodel.js";
import {continousRiskModel} from "../../models/continousriskmodel.js";
import {fieldModel} from "../../models/fieldmodel.js";

export class ProjectReportsWpActivDelivCtrl
{
	$scope;
	$filter;
	$http;
	$mdDialog;
	jsDataService;
	$mdDialog;
	item = {};
	fieldCfg = {};
	workpackages = [];
	justification_instruction = '';
	deliv_description_instruction = '';


	constructor($scope, $http, $filter, $mdDialog, jsDataService){

		'ngInject';
		this.$scope = $scope;
		this.$http = $http;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
//		this.workpackages = new projectModel(jsDataService.get('workpackages', {}), $filter, jsDataService);
		this.initWP(jsDataService.get('workpackage', {}));
		this.item = jsDataService.get('item', {});
		this.justification_instruction = this.$filter('tr')('project_activity_justification_instruction_tooltip');
		this.deliv_description_instruction = this.$filter('tr')('project_deliverable_description_instruction_tooltip');
	}

	initWP(workpackage){
		this.workpackage = [];

		this.workpackage = new wpModel(workpackage, this.$filter, this.jsDataService);
		if(typeof(this.workpackage.activities) !== 'undefined'){
			for(let activ in this.workpackage.activities){
				this.workpackage.activities[activ] = new wpActivityModel(this.workpackage.activities[activ], this.$filter, this.jsDataService);
			}
		}
		if(typeof(this.workpackage.deliverables) !== 'undefined'){
			for(let dlvr in workpackage.deliverables){
				workpackage.deliverables[dlvr] = (new reportWpDeliverableModel(workpackage.deliverables[dlvr], this.$filter, this.jsDataService));
				workpackage.deliverables[dlvr].attachments = Object.values(workpackage.deliverables[dlvr].attachments);
			}
		}
	}

	getParticipantField(id, field){
		if(id && typeof(id) === 'object'){
			let fields = [];
			for(let oneId of Object.values(id)){
				let participant = this.getParticipant(oneId);
				if(!participant){
					continue;
				}
				fields.push(participant.getValue(field));
			}
			if(fields.length > 0){
				return fields.join(', ');
			}
			return '';
		}
		else{
			let participant = this.getParticipant(id);
			if(!participant){
				return '';
			}
			return participant.getValue(field);
		}
	}

	getLeadBeneficiary(){
		if(typeof(this.workpackage.participants) === 'undefined'){
			return null;
		}
		let prtcps = this.$filter('filter')(this.workpackage.participants, {id: this.workpackage.a4_1_work_activities_lead}, false);
		if(prtcps.length < 1){
			return null;
		}
		let lead = new participantModel(prtcps[0], this.$filter, this.jsDataService);
		return lead.a3_participants_acronym;
	}

	getParticipant(id){
		if(typeof(this.workpackage.participants) === 'undefined'){
			return null;
		}
		let prtcps = this.$filter('filter')(this.workpackage.participants, {id: id}, true);
		if(prtcps.length < 1){
			return null;
		}
		return new participantModel(prtcps[0], this.$filter, this.jsDataService);
	}

	actionEdit(ev, node){
		if(this.isEdit(node)){
			this.$scope.goUrl(node.edit_url);
		}
	}

	/////
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}

	autosavePostFields(){
		let activitiesPost = [];
		for(let fkey in this.workpackage.activities){
			activitiesPost.push(this.workpackage.activities[fkey].getData());
		}
		return {
			activities: activitiesPost,
			other_issues: this.workpackage.other_issues
		};
	}

	clearStatus(activity){
		activity.completion_delayed = false;
	}

	editWpDeliv(ev, wpDeliv){
		this.wpDelivEditor(ev, wpDeliv);
	}

	wpDelivPreview(ev, wpDeliv){
//		console.log(wpDeliv)
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "notify", "wpDeliv", "item", this.wpDelivEditorDialogCtrl],
			templateUrl: 'projects/report_wp_deliv_preview.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wpDeliv: wpDeliv,
				item: this.item
			}
		}).then((results) => {
//			console.log('dialog close', results);
		}, () => {});
	}

	wpDelivEditor(ev, wpDeliv){
//		console.log(wpDeliv)
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "notify", "wpDeliv", "item", this.wpDelivEditorDialogCtrl],
			templateUrl: 'projects/report_wp_deliv_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wpDeliv: wpDeliv,
				item: this.item
			}
		}).then((results) => {
//			console.log('dialog close', results);
			this.postAction(wpDeliv, results);
		}, () => {});
	}

	postAction(wpDeliv, results){
		const url = wpDeliv[results.action+'_url'];
		if(url){
			this.isSaved = false;
			this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'POST',
				data: {
					deliv: results.deliv
				}
			}).then((response) => {

				if(response.data.success){
					wpDeliv = angular.extend(wpDeliv, response.data.item);
				}
				this.isSaved = true;

			}, () => {});
		}
		else{
			console.log('no url ', url);
		}
	}

	wpDelivEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, notify, wpDeliv, item){
		$scope.fileFilter = jsDataService.get('cfgFileFilter', {});
		$scope.maxFileSize = jsDataService.get('maxFileSize', 0);
		$scope.uploadUrl = jsDataService.get('cfgUploadUrl');
		$scope.deliv_description_instruction = $filter('tr')('project_deliverable_description_instruction_tooltip');
		$scope.attfile = {
			file: {}
		};
		$scope.dragClass = '';
		$scope.wpDeliv = angular.copy(wpDeliv);
		$scope.item = angular.copy(item);
//		$scope.wpDeliv.comment = '';

		if(typeof($scope.wpDeliv.proposed_due_date) !== 'undefined' && $scope.wpDeliv.proposed_due_date > 0){
			$scope.wpDeliv.proposed_due_date = new Date($scope.wpDeliv.proposed_due_date * 1000);
		}
		else{
			$scope.wpDeliv.proposed_due_date = null;
		}

		if(typeof($scope.wpDeliv.new_due_date) !== 'undefined' && $scope.wpDeliv.new_due_date > 0){
			$scope.wpDeliv.new_due_date = new Date($scope.wpDeliv.new_due_date * 1000);
		}
		else{
			$scope.wpDeliv.new_due_date = null;
		}

		$scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));

		$scope.fileUploaded = function($file, $message, $flow){
			if($file.response.success){
				$scope.attfile.file.file_id = $file.response.fileId;
				$scope.attfile.file.done = true;
				$scope.saveAttachment($scope.attfile);
			}
		};

		$scope.fileUploadedEsfa = function($file, $message, $flow){
			if($file.response.success){
				$scope.attfile.file.file_id = $file.response.fileId;
				$scope.attfile.file.done = true;
				$scope.saveAttachmentEsfa($scope.attfile);
			}
		};

		$scope.filesAdded = function($files){
			return true;
		};

		$scope.fileAdded = function($file){
			const ext = $file.getExtension();
			if(typeof($scope.fileFilter[ext]) === 'undefined' || !$scope.fileFilter[ext]){
				notify($filter('tr')('file_wrong_format'), true);
				return false;
			}
			if(typeof($scope.maxFileSize) !== 'undefined' && $file.size > $scope.maxFileSize){
				notify($file.name + ' - ' + $filter('tr')('file_size_error'), true);
				return false;
			}
			if(!$scope.activeUpload()){
				return false;
			}
			$scope.addFlowFile($file);
			return true;
		};

		$scope.fileSubmited = function(){
			$scope.attfile.flow.upload();
		};

		$scope.activeUpload = function(){
			return true;
		};

		$scope.classOnDrag = function(value){
			if($scope.activeUpload()){
				$scope.dragClass = value;
			}
		};

		$scope.classOffDrag = function(value){
			$scope.dragClass = value;
		};

		$scope.addFlowFile = function($file){
			let file = {
				file_id: '0',
				nrId: $file.uniqueIdentifier,
				file_name: $file.name,
				isFlow: true,
				flowFile: $file,
				done: false
			};
			$scope.attfile.file = file;
		};

		$scope.editDisabled = function(){
			return ($scope.wpDeliv.status == 2);
		};

		$scope.canApprove = function(){
			return ($scope.wpDeliv.status < 3);
		};

		$scope.canReject = function(){
			return ($scope.wpDeliv.status < 3);
		};

		$scope.proposedDateInvalid = function(){
			if($scope.showProposedDueDate()){
				if(parseInt($scope.convertDateToTimestamp($scope.wpDeliv.proposed_due_date))<parseInt($scope.wpDeliv.due_date_date)){
					return true;
				}
				if(parseInt($scope.convertDateToTimestamp($scope.wpDeliv.proposed_due_date))>parseInt($scope.item.end_date_date)){
					return true;
				}
			}
			return false;
		};

		$scope.showProposedDueDate = function(){
			return (parseInt($scope.convertDateToTimestamp(new Date()))>=parseInt($scope.wpDeliv.due_date_date));
		};

		$scope.noNonApprovedFile = function(){
			for(let attachment in $scope.wpDeliv.attachments){
				if($scope.wpDeliv.attachments[attachment].approved == '0'){
					return false;
					break;
				}
			}
			return true;
		};

		$scope.showNewDueDate = function(){
			return (parseInt($scope.convertDateToTimestamp(new Date()))>=parseInt($scope.wpDeliv.due_date_date));
		};

		$scope.newDueDateInvalid = function(){
			if($scope.showNewDueDate()){
				if(parseInt($scope.convertDateToTimestamp($scope.wpDeliv.new_due_date))<parseInt($scope.wpDeliv.due_date_date)){
					return true;
				}
				if(parseInt($scope.convertDateToTimestamp($scope.wpDeliv.proposed_due_date))>parseInt($scope.item.end_date_date)){
					return true;
				}
			}
			return false;
		};

		$scope.convertDateToTimestamp = function(date) {
			if (!date) {
				return null;
			}
			const timestamp = Math.floor(new Date(date).getTime() / 1000);
			if (isNaN(timestamp)) {
				return null;
			}
			return timestamp;
		};

		$scope.saveAttachment = function(attachment){
			if($scope.editDisabled()){
				return;
			}
			let data = {
				file_id: attachment.file.file_id,
				title: attachment.file.file_name.replace(/\.[a-z0-9]+$/, '')
			};
			if($scope.wpDeliv.file_add_url && $scope.wpDeliv.file_add_url !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: $scope.wpDeliv.file_add_url,
					method: 'POST',
					data: data
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						wpDeliv.status = response.data.item.status;
						$scope.wpDeliv.status = response.data.item.status;
						$scope.wpDeliv.attachments = response.data.item.attachments;
						$scope.attfile.file = {};
					}
				}, () => {});
			}
			else{
				console.log('no url ', $scope.wpDeliv.file_add_url);
			}
		};

		$scope.removeAttachment = function(ev, attachment){
			if($scope.editDisabled() || !$scope.allowRemoveSite(attachment)){
				return;
			}
			if($scope.wpDeliv.file_remove_url !== ''){
				const confirmTexts = jsDataService.get('attachmentRemoveConfirmTexts');
				const confirm = $mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.multiple(true) // Allow multiple dialogs
					.cancel(confirmTexts.cancel);
				$mdDialog.show(confirm).then(() => {
					$scope.$root.basicHttpConfigProcess({
						url: $scope.wpDeliv.file_remove_url,
						method: 'GET',
						responseType: 'json',
						params: {
							id: attachment.id
						}
					}).then((response) => {
						if(response.data.success && typeof(response.data.item) !== 'undefined'){
							wpDeliv.status = response.data.item.status;
							$scope.wpDeliv.status = response.data.item.status;
							$scope.wpDeliv.attachments = response.data.item.attachments;
						}
					});
				}, () => {});
			}
		};

		$scope.saveAttachmentEsfa = function(attachment){
			let data = {
				file_id: attachment.file.file_id,
				title: attachment.file.file_name.replace(/\.[a-z0-9]+$/, '')
			};
			if($scope.wpDeliv.file_add_url && $scope.wpDeliv.file_add_url !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: $scope.wpDeliv.file_add_url,
					method: 'POST',
					data: data
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						$scope.wpDeliv.attachments = response.data.item.attachments;
						$scope.attfile.file = {};
					}
				}, () => {});
			}
			else{
				console.log('no url ', $scope.wpDeliv.file_add_url);
			}
		};

		$scope.removeAttachmentEsfa = function(ev, attachment){
			if($scope.wpDeliv.file_remove_url !== ''){
				const confirmTexts = jsDataService.get('attachmentRemoveConfirmTexts');
				const confirm = $mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.multiple(true) // Allow multiple dialogs
					.cancel(confirmTexts.cancel);
				$mdDialog.show(confirm).then(() => {
					$scope.$root.basicHttpConfigProcess({
						url: $scope.wpDeliv.file_remove_url,
						method: 'GET',
						responseType: 'json',
						params: {
							id: attachment.id
						}
					}).then((response) => {
						if(response.data.success && typeof(response.data.item) !== 'undefined'){

							$scope.wpDeliv.attachments = response.data.item.attachments;
						}
					});
				}, () => {});
			}
		};

		$scope.calcAchievedQuantity = function(){
			let achievedQuantity = parseInt($scope.wpDeliv.quantity_per_period)+parseInt($scope.wpDeliv.confirmed_quantity);
			if(isNaN(achievedQuantity)){
				return "0";
			}
			return achievedQuantity;
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.isValid = function(){
			if($scope.editDisabled() || $scope.proposedDateInvalid()){
				return false;
			}
			return ($scope.wpDeliv.attachments.length>0 && $scope.wpDeliv.description!=='');
		};

		$scope.isValidEsfa = function(){
			if($scope.newDueDateInvalid()){
				return false;
			}
			return ($scope.wpDeliv.description!=='');
		};

		$scope.submitDeliverable = function(ev){
			if(!$scope.isValid()){
				return;
			}
			const confirmTexts = jsDataService.get('deliverableSubmitConfirmTexts');
			const confirm = $mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.multiple(true) // Allow multiple dialogs
				.cancel(confirmTexts.cancel);
			$mdDialog.show(confirm).then(() => {
				let data = {
					deliv : $scope.wpDeliv.getData(),
					action : 'submit'
				};
				if($scope.showProposedDueDate()){
					data.deliv.proposed_due_date = $filter('date')($scope.wpDeliv.proposed_due_date, 'yyyy-MM-dd');
				}
				else{
					data.deliv.proposed_due_date = '0';
				}
				$mdDialog.hide(data);
			}, () => {});

		};

		$scope.saveDeliverable = function(ev){
			let data = {
				deliv : $scope.wpDeliv.getData(),
				action : 'save'
			};
			if($scope.showProposedDueDate()){
				data.deliv.proposed_due_date = $filter('date')($scope.wpDeliv.proposed_due_date, 'yyyy-MM-dd');
			}
			else{
				data.deliv.proposed_due_date = '0';
			}
			$mdDialog.hide(data);
		};

		$scope.saveDeliverableEsfa = function(ev){
			let data = {
				deliv : $scope.wpDeliv.getData(),
				action : 'save'
			};

			if($scope.wpDeliv.new_due_date!==''){
				data.deliv.new_due_date = $filter('date')($scope.wpDeliv.new_due_date, 'yyyy-MM-dd');
			}
			else{
				data.deliv.new_due_date = '0';
			}
			$mdDialog.hide(data);
		};

		$scope.rejectDeliverable = function(ev){
			if(!$scope.isValidEsfa()){
				return;
			}
			const confirmTexts = jsDataService.get('deliverableRejectConfirmTexts');
			const confirm = $mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.multiple(true) // Allow multiple dialogs
				.cancel(confirmTexts.cancel);
			$mdDialog.show(confirm).then(() => {
				let data = {
					deliv : $scope.wpDeliv.getData(),
					action : 'reject'
				};
				if($scope.showNewDueDate()){
					data.deliv.new_due_date = $filter('date')($scope.wpDeliv.new_due_date, 'yyyy-MM-dd');
				}
				else{
					data.deliv.new_due_date = '0';
				}
				$mdDialog.hide(data);
			}, () => {});

		};

		$scope.approveDeliverable = function(ev){
			if(!$scope.isValidEsfa()){
				return;
			}
			const confirmTexts = jsDataService.get('deliverableApproveConfirmTexts');
			const confirm = $mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.multiple(true) // Allow multiple dialogs
				.cancel(confirmTexts.cancel);
			$mdDialog.show(confirm).then(() => {
				let data = {
					deliv : $scope.wpDeliv.getData(),
					action : 'approve'
				};
				if($scope.showNewDueDate()){
					data.deliv.new_due_date = $filter('date')($scope.wpDeliv.new_due_date, 'yyyy-MM-dd');
				}
				else{
					data.deliv.new_due_date = '0';
				}
				$mdDialog.hide(data);
			}, () => {});

		};
		$scope.allowRemoveSite = function(attachment){
			return (attachment.approved=='0' && attachment.allowremove && ($scope.wpDeliv.status=='0' || $scope.wpDeliv.status=='1' || $scope.wpDeliv.status=='3'));
		};

		$scope.allowRemoveEsfa = function(attachment){
			return (attachment.allowremove);
		};

		$scope.getClassif = function(name){
			if(typeof($scope.classif[name]) === 'undefined'){
				return [];
			}
			if(typeof($scope.classif[name][0].active) === 'undefined'){
				return $scope.classif[name];
			}
			return $filter('filter')($scope.classif[name], {active: 1});
		};

	}

}